export const normalizeShipmentVehicleTypeForApi = vehicleType => {
  const normalizedVehicleType = typeof vehicleType === 'string' ? vehicleType.trim().toLowerCase().replace(/\s+/g, '_') : '';

  switch (normalizedVehicleType) {
    case 'pickup_truck':
      return 'truck';
    case 'heavy_duty_truck':
      return 'heavy_duty_truck';
    case 'bumper_pull':
    case 'bumper_pull_trailer':
      return 'trailer';
    case 'gooseneck':
      return 'gooseneck_trailer';
    case 'flatbed':
      return 'trailer';
    case 'dry_van':
      return '18_wheeler_dry_van';
    case 'reefer':
      return '18_wheeler_reefer';
    case '18_wheeler_flatbed':
      return '18_wheeler_flat_bed';
    case '18_wheeler_dryvan':
      return '18_wheeler_dry_van';
    default:
      return normalizedVehicleType;
  }
};

const RANGE_QUOTE_VEHICLE_TYPES = new Set(['18_wheeler_dry_van', '18_wheeler_flat_bed', '18_wheeler_reefer', 'car_hauler']);
const LIFTGATE_VEHICLE_TYPES = new Set(['box_truck', '18_wheeler_dry_van']);

export const requiresRangeQuoteForVehicleType = vehicleType => RANGE_QUOTE_VEHICLE_TYPES.has(normalizeShipmentVehicleTypeForApi(vehicleType));

export const supportsLiftgateForVehicleType = vehicleType => LIFTGATE_VEHICLE_TYPES.has(normalizeShipmentVehicleTypeForApi(vehicleType));

export const formatShipmentVehicleTypeLabel = vehicleType => {
  const normalizedVehicleType = normalizeShipmentVehicleTypeForApi(vehicleType);

  switch (normalizedVehicleType) {
    case 'pickup_truck':
    case 'truck':
      return '1/2 Ton Pickup';
    case 'heavy_duty_truck':
      return '1 Ton Pickup';
    case 'car':
      return 'Car';
    case 'suv':
      return 'SUV';
    case 'sprinter_van':
      return 'Sprinter Van';
    case 'box_truck':
      return 'Box Truck';
    case 'trailer':
      return 'Truck and Trailer';
    case 'gooseneck_trailer':
      return 'Gooseneck Trailer';
    case 'car_hauler':
      return 'Car Hauler';
    case '18_wheeler_dry_van':
      return '18 Wheeler Dry Van';
    case '18_wheeler_flat_bed':
      return '18 Wheeler Flat Bed';
    case '18_wheeler_reefer':
      return '18 Wheeler Reefer';
    case 'enclosed_trailer':
      return 'Enclosed Trailer';
    case 'dump_trailer':
      return 'Dump Trailer';
    default:
      return normalizedVehicleType
        ? normalizedVehicleType
            .split('_')
            .map(segment => segment.charAt(0).toUpperCase() + segment.substring(1))
            .join(' ')
        : '';
  }
};